const PATHS = {};

PATHS.LOGIN = "/login";
PATHS.HOME = "/user/home";
PATHS.EXTERNAL_CONFIRM_LOGIN = "/authConfirm/:token";

PATHS.USERS = "/user/users/list";

// INIT VIVERO PATHS
PATHS.VIVERO = "/user/vivero";
PATHS.VIVERO_LIST = "/user/vivero/list";
PATHS.CREATE_VIVERO = "/user/vivero/form/new";
PATHS.UPDATE_VIVERO = "/user/vivero/form/update/:uuid";
// END VIVERO PATHS

// INIT VARIETY PATHS
PATHS.VARIETY = "/user/variety";
PATHS.VARIETY_LIST = "/user/variety/list";
PATHS.CREATE_VARIETY = "/user/variety/form/new";
PATHS.UPDATE_VARIETY = "/user/variety/form/update/:uuid";
// END VARIETY PATHS

// INIT BATCH PATHS
PATHS.BATCH = "/user/batch";
PATHS.BATCH_LIST = "/user/batch/list";
PATHS.CREATE_BATCH = "/user/batch/form/new";
PATHS.UPDATE_BATCH = "/user/batch/form/update/:uuid";
// END BATCH PATHS

// INIT TASK PATHS
PATHS.TASK = "/user/task";
PATHS.TASK_LIST = "/user/task/list";
PATHS.CREATE_TASK = "/user/task/form/new";
PATHS.UPDATE_TASK = "/user/task/form/update/:uuid";
// END TASK PATHS

// INIT ARTICLE PATHS
PATHS.ARTICLE = "/user/article";
PATHS.ARTICLE_LIST = "/user/article/list";
PATHS.CREATE_ARTICLE = "/user/article/form/new";
PATHS.UPDATE_ARTICLE = "/user/article/form/update/:uuid";
// END ARTICLE PATHS

// INIT LOCATION PATHS
PATHS.LOCATION = "/user/location";
PATHS.LOCATION_LIST = "/user/location/list";
PATHS.CREATE_LOCATION = "/user/location/form/new";
PATHS.UPDATE_LOCATION = "/user/location/form/update/:uuid";
// END LOCATION PATHS

// INIT SECTOR PATHS
PATHS.SECTOR = "/user/sector";
PATHS.SECTOR_LIST = "/user/sector/list";
PATHS.CREATE_SECTOR = "/user/sector/form/new";
PATHS.UPDATE_SECTOR = "/user/sector/form/update/:uuid";
// END SECTOR PATHS

// INIT CODE PATHS
PATHS.CODE = "/user/code";
PATHS.CODE_LIST = "/user/code/list";
PATHS.CREATE_CODE = "/user/code/form/new";
PATHS.UPDATE_CODE = "/user/code/form/update/:uuid";
// END CODE PATHS

// INIT WORKING_PART PATHS
PATHS.WORKING_PART = "/user/workingPart";
PATHS.WORKING_PART_LIST = "/user/workingPart/list";
PATHS.ALL_WORKING_PART_LIST = "/user/workingPart/unbundled";
PATHS.CREATE_WORKING_PART = "/user/workingPart/form/new";
PATHS.UPDATE_WORKING_PART = "/user/workingPart/form/update/:uuid";
PATHS.DETAIL_WORKING_PART = "/user/workingPart/detail/:uuid";

// END WORKING_PART PATHS

PATHS.MY_WORKING_PART_LIST = "/technical/workingPart/list";
PATHS.TEC_CREATE_WORKING_PART = "/technical/workingPart/form/new";
PATHS.TEC_DETAIL_WORKING_PART = "/technical/workingPart/detail/:uuid";

/* GENERATOR_INJECT_PATHS */

PATHS.MERMA_PART_LIST = "/user/mermaPart/list";
PATHS.REPORTS = "/user/reports";

export default PATHS;
